module.exports = __webpack_public_path__ + "static/media/1_James_S@3x.98bc16ac.jpg";